import * as React from "react";
import NextApp from "next/app";
import { CookieConsentContextProvider } from "@grandvisionhq/cookie-consent";
import { getDisplayName } from "@grandvisionhq/utils";
function withConsent(consentProvider) {
  return () => (PageComponent) => {
    const displayName = getDisplayName(PageComponent);
    const WithConsent = (pageProps) => {
      return /* @__PURE__ */ React.createElement(
        CookieConsentContextProvider,
        {
          cookies: pageProps.cookies,
          consentProvider
        },
        /* @__PURE__ */ React.createElement(PageComponent, { ...pageProps })
      );
    };
    WithConsent.getInitialProps = async (appContext) => {
      const inAppContext = Boolean(appContext.ctx);
      let pageProps = {};
      if (PageComponent.getInitialProps) {
        pageProps = await PageComponent.getInitialProps(appContext);
      } else if (inAppContext) {
        pageProps = await NextApp.getInitialProps(appContext);
      }
      const cookies = appContext.ctx.req?.cookies ?? {};
      if (typeof PageComponent.getInitialProps === "function") {
        return {
          ...pageProps,
          cookies
        };
      }
      return {
        cookies
      };
    };
    WithConsent.displayName = `WithConsent(${displayName})`;
    return WithConsent;
  };
}
export {
  withConsent
};
//# sourceMappingURL=with-consent.js.map
